import { getMemberComplaints } from "../../Redux/Assets/AssetsActions";
import { ColDef, GridReadyEvent } from "ag-grid-community";
import Loading from "../../Components/Common/Loading/Loading";
import { AppDispatch, RootState } from "../../Redux/store";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { IoCloseSharp } from "react-icons/io5";
import { AgGridReact } from "ag-grid-react";
import styles from "./Help.module.scss";
import moment from "moment";

interface HelpType {
  id: number;
  comments: string;
  status: number;
  statusName: string;
  createdBy: number;
  createdByName: string;
  createdAt: string;
  modifiedBy: number | null;
  modifiedAt: string | null;
  typeId: number;
  typeName: string;
  amenityId: number | null;
  amenityName: string | null;
  assetId: number | null;
  assetName: string | null;
}

const defaultColDef: ColDef = {
  resizable: true,
  sortable: true,
  filter: false,
  wrapText: true,
  autoHeight: true,
  unSortIcon: true,
};

function Help() {
  const dispatch = useDispatch<AppDispatch>();
  const { memberComplaintsData, memberComplaintsLoading } = useSelector(
    (state: RootState) => state.assets,
  );
  const [rowData, setRowData] = useState<HelpType[]>([]);
  const [gridApi, setGridApi] = useState<any>(null);
  const [search, setSearch] = useState("");

  const filteredRowData = rowData?.filter((item) => {
    const searchValue = search?.toLowerCase();
    if (!searchValue) return true;

    return (
      item?.amenityName?.toLowerCase()?.includes(searchValue) ||
      item?.typeName?.toLowerCase()?.includes(searchValue) ||
      item?.assetName?.toLowerCase()?.includes(searchValue) ||
      item?.statusName?.toLowerCase()?.includes(searchValue)
    );
  });

  const onGridReady = (params: GridReadyEvent) => {
    setGridApi(params?.api);
    params?.api?.sizeColumnsToFit();
  };

  const columnDefs: ColDef<HelpType>[] = [
    {
      headerName: "Type",
      field: "typeName",
      flex: 1,
      minWidth: 120,
    },
    {
      headerName: "Amenity",
      field: "amenityName",
      flex: 1,
      minWidth: 150,
      valueGetter: (params) => params?.data?.amenityName || "N/A",
    },
    {
      headerName: "Asset",
      field: "assetName",
      flex: 1,
      minWidth: 150,
      valueGetter: (params) => params?.data?.assetName || "N/A",
    },
    {
      headerName: "Comments",
      field: "comments",
      flex: 1,
      minWidth: 200,
    },
    {
      headerName: "Status",
      field: "statusName",
      flex: 1,
      minWidth: 120,
      cellClass: (params) => {
        const status = params?.data?.statusName?.toLowerCase();
        if (status === "pending") return "expiredText";
        if (status === "solved") return "activeText";
        return "";
      },
    },
    {
      headerName: "Created At",
      field: "createdAt",
      flex: 1,
      minWidth: 140,
      valueGetter: (params) => {
        return params?.data?.createdAt
          ? moment(params.data.createdAt).format("MM/DD/YYYY")
          : "N/A";
      },
    },
  ];

  useEffect(() => {
    if (!gridApi) return;

    const handleResize = () => {
      gridApi?.sizeColumnsToFit();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [gridApi]);

  useEffect(() => {
    dispatch(getMemberComplaints());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (memberComplaintsData) {
      setRowData(memberComplaintsData);
    }
  }, [memberComplaintsData]);

  return (
    <React.Fragment>
      {memberComplaintsLoading && <Loading />}
      <div className={styles.mainContainer}>
        <div className={styles.topContainer}>
          <div className={styles.headingContainer}>
            <h1 className={styles.heading}>Tickets</h1>
          </div>
          <div className={styles.buttonContainer}></div>
        </div>
        <div className={styles.bodyContainer}>
          <div className={styles.searchContainer}>
            <input
              type="text"
              className={styles.input}
              placeholder="Search"
              value={search}
              onChange={(e) => setSearch(e?.target?.value || "")}
            />
            <div className={styles.iconContainer} onClick={() => setSearch("")}>
              <IoCloseSharp className={styles.icon} />
            </div>
          </div>

          <div className={styles.gridContainer}>
            <AgGridReact
              className={styles.grid}
              rowData={filteredRowData}
              columnDefs={columnDefs}
              defaultColDef={defaultColDef}
              onGridReady={onGridReady}
              pagination={true}
              paginationPageSize={10}
              paginationPageSizeSelector={[5, 10, 20, 50, 100]}
              animateRows={true}
              domLayout="autoHeight"
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Help;
